<template>
    <div class="dashboard">
        <p class="welcome-title">Welcome back!</p>
        <div class="card-grid">
            <div v-for="card in cards" :key="card.title" class="card">
                <div class="icon-parent-container">
                    <div class="icon-container">
                        <component :is="card.icon" class="icon" />
                    </div>
                </div>
                <h3>{{ card.title }}</h3>
                <p class="card-value">{{ card.value }}</p>
            </div>
        </div>
        <!-- Bar Chart Section -->
        <div class="chart-section">
            <h2>Analytics Overview</h2>
            <BarChart :members="members" :applications="applications" :booking="booking" :tournament="tournament"  />
        </div>
        
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { Users, FileText, CalendarCheck, Trophy } from "lucide-vue-next";
import BarChart from "@/components/BarChart.vue";
import axios from 'axios';

const isMobile = ref(false);
const showMobileSidebar = ref(false);
const members = ref('');
const applications = ref('');
const booking = ref('');
const tournament = ref('');

function handleResize() {
    isMobile.value = window.innerWidth <= 768;
    if (!isMobile.value) {
        showMobileSidebar.value = false;
    }
}

// onMounted(() => {
//     handleResize();
//     window.addEventListener("resize", handleResize);
// });
onMounted(async () => {
    handleResize();
window.addEventListener("resize", handleResize);

    const res = await axios.get('/dashboard_analytics.php');
    const data = res.data.data

    members.value = data.totalMembers;
    applications.value = data.totalApplications;
    booking.value = data.bookings;
    tournament.value = data.tournaments;

    cards.value[0].value = data.totalMembers;
    cards.value[1].value = data.totalApplications;
    cards.value[2].value = data.bookings;
    cards.value[3].value = data.tournaments;
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
});

// Dashboard cards
const cards = ref([
    { title: "Total Members", value: 0, icon: Users },
    { title: "Total Applications", value: 0, icon: FileText },
    { title: "Bookings", value: 0, icon: CalendarCheck },
    { title: "Tournaments", value: 0, icon: Trophy },
]);
</script>

<style scoped>
.chart-section {
    margin-top: 40px;
    background: #fff;
    padding: 20px;
    border-radius: 16px;
    border: 1px solid #DCE3E7;
}

.chart-section h2 {
    margin-bottom: 16px;
    font-size: 20px;
}
.card-value {
    font-size: 28px;
    font-weight: bold;
    margin-top: 8px;
    color: #111827;
}
.welcome-title{
    text-align: left;
}
.dashboard {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f9fafb;
    padding: 4px;
}

.dashboard h2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
}

.card-grid {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr;
    /* mobile = 1 column */
    gap: 24px;
}

.card {
    background: white;
    border-radius: 16px;
    padding: 14px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s ease;
    cursor: pointer;
    border: 1px solid #DCE3E7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card .icon-parent-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    border: 1px solid #DCE3E7;
    margin-bottom: 20px;
}

.card .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(to bottom, #ADB5BD, #1E1E1E);
}

.card .icon {
    width: 28px;
    height: 28px;
    color: #fff;
}

.card h3 {
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin: 0;
}

/* Tablet */
@media (min-width: 768px) {
    .dashboard {
        padding: 26px;
    }

    .card-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* Large screen */
@media (min-width: 1024px) {
    .dashboard {
        padding: 26px;
    }

    .card-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>
